<template>
  <div class="two-column-view">
    <div class="article-content">
      <h1>Investor Center</h1>
      <p>
        <strong
          >The Goldenlink+ Investor Center is open to large and small
          investors.</strong
        ><br />
        We currently offer a whitelisting opportunity for our upcoming ICO
        Investment.
      </p>
      <p><strong>Take advantage of our whitelist benefits.</strong></p>
      <ol>
        <li>
          Get an equal share of traffic tokens with the initial price - GSCoin.
        </li>
        <li>
          GOLD will reserve 5% of the annual profit in the fund pool and
          distribute it accordingly to each investor. GOLD shall also reserve
          ICO investment and financing opportunities in the future according to
          business and development needs.
        </li>
        <li>
          As the platform continues to scale up, GOLD will upgrade more
          minership features and benefits and get your applications prioritized.
          You may apply to select your ICO investment to the corresponding
          minership if you want to limit your spending.
        </li>
        <li>
          Use our NFT Auction or market trading feature as an exit strategy to
          transfer equity, rights, and interests to other Mineer or buyer. For
          more details, please check our Terms and Conditions.
        </li>
      </ol>
      <p>To apply for our whitelist, please click the button below</p>
      <div v-if="showForm" class="application-form">
        <InvestorForm @submitted="showForm = false" />
      </div>
      <div v-else @click="showForm = true" class="btn btn-gold px-5 text-white">
        Apply Now
      </div>
    </div>
    <div class="right-side-column">
      <div class="column-image">
        <img src="../assets/Investors.png" alt="Investors" />
      </div>
      <p>Contact Goldenlink+ to schedule an appointment.</p>
    </div>
  </div>
</template>

<script>
import InvestorForm from "@/components/InvestorForm.vue";

export default {
  data() {
    return {
      showForm: false,
    };
  },
  components: {
    InvestorForm,
  },
};
</script>

<style scoped></style>
